// extracted by mini-css-extract-plugin
export default {"user-list":"UserList_user-list__UanoN","single":"UserList_single__K9tXw"};